import { createSlice } from '@reduxjs/toolkit';
import { ProviderTransferCompaniesListStateType } from '../../types/providerTransferCompaniesList';

const initialState: ProviderTransferCompaniesListStateType = {
    data: null,
    loading: false,
    error: false,
};
export const providerTransferCompaniesSlice = createSlice({
    name: 'providerTransferCompaniesList',
    initialState,
    reducers: {
        getProviderTransferCompaniesListFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getProviderTransferCompaniesListFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getProviderTransferCompaniesListFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getProviderTransferCompaniesListFetch,
    getProviderTransferCompaniesListFetchSuccess,
    getProviderTransferCompaniesListFetchFailure,
} = providerTransferCompaniesSlice.actions;

export default providerTransferCompaniesSlice.reducer;
